import { NativeEventEmitter } from "react-native";

const emitter = new NativeEventEmitter();

export default emitter;
